import { createFileRoute } from '@tanstack/react-router';
import { SkillForm } from '@/components/skills/form/SkillForm.tsx';

export const Route = createFileRoute('/_app/skills/create')({
  staticData: { orgScope: 'none' },
  component: () => <SkillForm />,
});
